<template>
    <td-dialog
        :title="title"
        append-to-body="true"
        width="300px"
        :before-close="dialogClose"
        :visible.sync="dialogEventSubVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="formInfo" ref="formInfo" label-position="right" :label-width="formLabelWidth" :rules="rules">
            <el-form-item :label="$t('common.ALARM_SERIAL_NUMBER')" prop="sNumber">
                <td-input v-model="formInfo.sNumber" :disabled="sNumberDisabled" maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.NAME')" prop="sName">
                <td-input v-model="formInfo.sName" maxlength="50"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('formInfo')" :loading="loading">{{ $t('common.SURE') }}</td-button>
            <td-button type="button" @click.native="dialogClose">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    props: ['title', 'dialogEventSubVisible', 'editItem', 'isAddData'],
    created() {
        if (!this.isAddData) {
            this.initEditData();
        }
    },
    // 定义变量
    data() {
        return {
            formInfo: {
                sNumber: '',
                sName: ''
            },
            formLabelWidth: '60px',
            loading: false,
            sNumberDisabled: false,
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('component.PLEASE_ENTER_NAME'), trigger: 'blur' },
                    {
                        pattern: this.$regex.CAPTION_RULE,
                        message: this.$t('error.ERROR_CAPTION_ILLEGAL')
                    }
                ],
                sNumber: [
                    { required: true, message: this.$t('pgRegex.PLEASE_ENTER_SERIAL_NUMBER'), trigger: 'blur' },
                    { pattern: this.$regex.NUM, message: this.$t('pgRegex.SERIAL_NUMBER_ILLEGAL_AlARM_EVENT') }
                ]
            }
        };
    },

    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formInfo.sName = this.editItem.sName;
            this.formInfo.sNumber = this.editItem.sNumber;
            this.sNumberDisabled = true;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    let content = {};
                    content.sName = this.formInfo.sName;
                    content.sNumber = this.formInfo.sNumber;
                    if (!this.isAddData) {
                        content.sId = this.editItem.sId;
                    }
                    this.loading = false;
                    this.$emit('saveEventSubInfo', content);
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        dialogClose() {
            this.$emit('dialogClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.calssRuleTitle {
    height: 30px;
    width: 482px;
    background-color: #e8e8e8;
    padding-left: 10px;
    color: #686868;
    display: table-cell;
    vertical-align: middle;
}
.classRuleContent {
    border: 1px solid #e8e8e8;
    width: 480px;
    padding-left: 10px;
    padding-bottom: 10px;
}
</style>
